var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import Sticky from 'react-stickynode';
import { css, mq, styled } from "../utils";
import Text from "./Text";
var StyledStickyPrice = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n      height: 40px;\n      box-sizing: border-box;\n      border-top: 1px solid gray;\n      box-shadow: ", ";\n      justify-content: space-between;\n      padding: 0 1rem;\n    "], ["\n      background: ", ";\n      height: 40px;\n      box-sizing: border-box;\n      border-top: 1px solid gray;\n      box-shadow: ", ";\n      justify-content: space-between;\n      padding: 0 1rem;\n    "])), colors.white, "0 5px 5px -5px  " + colors.gray);
}, mq({
    display: ['flex', 'flex', 'none'],
}));
var MobileStickyBanner = function (_a) {
    var label = _a.label, value = _a.value, className = _a.className;
    return (React.createElement(Sticky, { innerZ: 11 },
        React.createElement(StyledStickyPrice, { "data-component": "MobileStickyBanner", id: "section-sticky-header", className: className },
            React.createElement(Text, null, label),
            React.createElement(Text, { bold: true }, value))));
};
export default MobileStickyBanner;
var templateObject_1;
//# sourceMappingURL=MobileStickyBanner.js.map